import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-modal-close-button',
  templateUrl: './modal-close-button.component.html',
  styleUrls: ['./modal-close-button.component.scss'],
  imports: [MatIconModule],
})
export class ModalCloseButtonComponent {
  constructor() {}
  @Input() closeDialog: (value: boolean) => void;
}
